import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { FuseConfigService } from '../../../../@fuse/services/config.service';
import { fuseAnimations } from '../../../../@fuse/animations';
import { GT2FormPageAbstract } from '../../../gt2/content/abstract/GT2FormPageAbstract';
import { locale as english } from './i18n/en-CA';
import { locale as french } from './i18n/fr-CA';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { FuseTranslationLoaderService } from '../../../../@fuse/services/translation-loader.service';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { NGXLogger } from 'ngx-logger';
import { AppRoutesService } from '../../../gt2/services/app-routes.service';
import { SupportContactService } from '../../../gt2/content/contact/support-contact.service';
import { Settings } from '../../../gt2/settings/settings';
import { GenericAlertComponent } from '../../../gt2/components/generic-alert/generic-alert.component';
import { AppRoutes } from '../../../gt2/const/AppRoutes';
import { environment } from '../../../../environments/environment';
import { Title } from '@angular/platform-browser';
import { JwtInterceptor } from '../../../gt2/interceptors/JwtInterceptor';
import { FuseSplashScreenService } from '../../../../@fuse/services/splash-screen.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class MaintenanceComponent
  extends GT2FormPageAbstract
  implements OnInit, AfterViewInit, OnDestroy
{
  static readonly AUTO_CHECK_INTERVAL_SECONDS = 30;
  form: UntypedFormGroup | any;
  retrying: boolean = false;
  countdown: number = MaintenanceComponent.AUTO_CHECK_INTERVAL_SECONDS;
  private countdownIntervalId: any = null;
  /*
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   */
  constructor(
    private _fuseConfigService: FuseConfigService,
    private router: Router,
    public location: Location,
    private translationLoader: FuseTranslationLoaderService,
    public translate: TranslateService,
    public dialog: MatDialog,
    private logger: NGXLogger,
    private formBuilder: UntypedFormBuilder,
    private titleService: Title,
    public appRoutesService: AppRoutesService,
    private supportContactService: SupportContactService,
    private splashScreen: FuseSplashScreenService,
    private http: HttpClient,
  ) {
    super();
    this.translationLoader.loadTranslations(english, french);

    // Configure the layout
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };

    //
    this.form = this.formBuilder.group({
      subject: [
        '',
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
          Validators.required,
        ],
      ],
      message: [
        '',
        [Validators.minLength(Settings.inputMinChar), Validators.required],
      ],
    });

  }

  ngOnInit() {
    this.splashScreen.hide();
    this.startAutoCheck();
  }

  ngAfterViewInit() {}

  ngOnDestroy() {
    this.stopAutoCheck();
    JwtInterceptor.IS_MAINTENANCE_MODE = false;
  }

  private startAutoCheck(): void {
    this.stopAutoCheck();
    this.countdown = MaintenanceComponent.AUTO_CHECK_INTERVAL_SECONDS;
    this.countdownIntervalId = setInterval(() => {
      if (this.retrying) {
        return;
      }
      this.countdown -= 1;
      if (this.countdown <= 0) {
        this.countdown = MaintenanceComponent.AUTO_CHECK_INTERVAL_SECONDS;
        this.onRetry();
      }
    }, 1000);
  }

  private stopAutoCheck(): void {
    if (this.countdownIntervalId !== null) {
      clearInterval(this.countdownIntervalId);
      this.countdownIntervalId = null;
    }
  }

  public override onPageBack(): void {
    // this.logger.info(">>>>>>>>> ==> " + window.history.length);
    if (window.history.length > 1) {
      this.location.back();
    } else {
      const prefix = (localStorage.getItem('PREFIX') || '') + '/';
      this.router.navigateByUrl(prefix + AppRoutes.EVENTS);
    }
  }

  public onRetry(): void {
    if (this.retrying) {
      return;
    }
    this.retrying = true;
    JwtInterceptor.IS_MAINTENANCE_MODE = false;
    const healthUrl = environment.api.baseUrl + '/api/v1/employees/me';
    this.http.get(healthUrl).subscribe({
      next: () => {
        this.redirectAfterMaintenance();
      },
      error: (error) => {
        this.retrying = false;
        if (error.status === 503) {
          JwtInterceptor.IS_MAINTENANCE_MODE = true;
          this.countdown = MaintenanceComponent.AUTO_CHECK_INTERVAL_SECONDS;
        } else {
          this.redirectAfterMaintenance();
        }
      },
    });
  }

  // Restore the page the user was on before maintenance kicked in.
  // Priority: in-memory LAST_URL_503 → sessionStorage backup → org root.
  // Falls through to the org root when the stored URL is missing/invalid or
  // is itself the maintenance route (defensive, avoids loops).
  private redirectAfterMaintenance(): void {
    const fallback = '/' + (localStorage.getItem('PREFIX') || '');
    const stored =
      JwtInterceptor.LAST_URL_503 ||
      sessionStorage.getItem(JwtInterceptor.MAINTENANCE_RETURN_URL_KEY);

    sessionStorage.removeItem(JwtInterceptor.MAINTENANCE_RETURN_URL_KEY);
    JwtInterceptor.LAST_URL_503 = null;

    const target =
      stored &&
      stored.startsWith('/') &&
      stored.indexOf(AppRoutes.MAINTENANCE) < 0
        ? stored
        : fallback;

    window.location.href = target;
  }

  public onVisitGt2(): void {
    window.open(environment.gt2Website, '_blank');
  }

}
